import React from 'react';
import PropTypes from 'prop-types';

import RadioButton from 'components/RadioButton';

import { CHART_TAIL_TYPES } from 'store/scenes/distributions/chart/enums';
import LineChart from './LineChart';
import BarChart from './BarChart';

const PROBABILITY = 'Probability';
const LINE_CHART = 'Line Chart';

const DistributionChartComponent = props =>
  <div className="content-item">
    <div className="flex space-between">
      <p className="font-700 mb-10">
        { props.typeDistribution === 'binomial' ? PROBABILITY : LINE_CHART }
      </p>
    </div>

    <div key="radio-buttons" className="text-right">
      <RadioButton
        name="tail-type"
        labelClassName="ml-30"
        value={CHART_TAIL_TYPES.LEFT}
        onChange={props.onChartTailTypeChange}
        checked={props.tailType === CHART_TAIL_TYPES.LEFT}
      >

        Left Tail
      </RadioButton>

      <RadioButton
        name="tail-type"
        labelClassName="ml-30"
        value={CHART_TAIL_TYPES.RIGHT}
        onChange={props.onChartTailTypeChange}
        checked={props.tailType === CHART_TAIL_TYPES.RIGHT}
      >

        Right Tail
      </RadioButton>
      <RadioButton
        name="tail-type"
        labelClassName="ml-30"
        value={CHART_TAIL_TYPES.BOTH}
        onChange={props.onChartTailTypeChange}
        checked={props.tailType === CHART_TAIL_TYPES.BOTH}
      >

        Both Tails
      </RadioButton>

      <RadioButton
        name="tail-type"
        labelClassName="ml-30"
        value={CHART_TAIL_TYPES.CENTER}
        onChange={props.onChartTailTypeChange}
        checked={props.tailType === CHART_TAIL_TYPES.CENTER}
      >

        Between
      </RadioButton>

      {props.typeDistribution === 'binomial' && (
        <RadioButton
          name="tail-type"
          labelClassName="ml-30"
          value={CHART_TAIL_TYPES.EQUAL}
          onChange={props.onChartTailTypeChange}
          checked={props.tailType === CHART_TAIL_TYPES.EQUAL}
        >
          Equal
        </RadioButton>)
      }
    </div>
    {props.typeDistribution === 'binomial'
      ? (<BarChart />)
      : (<LineChart />)
    }
  </div>;

DistributionChartComponent.propTypes = {
  tailType: PropTypes.string.isRequired,
  typeDistribution: PropTypes.string.isRequired,
  onChartTailTypeChange: PropTypes.func.isRequired
};

export default DistributionChartComponent;
